import { Flex, Box } from "@chakra-ui/react";
import time from "src/utils/time";
import SvgContainer from "src/components/SvgContainer";
import { Lottie } from "src/components/Lottie";
import { Subtitle2 } from "src/atoms/typography";
import { ReactComponent as ScheduledIcon } from "../icons/scheduled.svg";

export default function Waiting({ scheduledMonitoring, scheduler, t }) {
  function getCorrespondingString() {
    if (!scheduler || !scheduledMonitoring) return null;

    const closestDay = scheduler.getClosestDay(scheduledMonitoring);
    const isScheduledForToday = scheduler.dayName === closestDay;
    const todayIndex = scheduler.getDayIndex(scheduler.dayName);
    const isTomorrow = closestDay === scheduler.weekDays[todayIndex + 1];
    const isNextWeek =
      isScheduledForToday &&
      scheduledMonitoring?.days?.length === 1 &&
      scheduler.currentMs > scheduler.getMilliseconds(scheduledMonitoring.startTime);
    const startDate = time().set({
      hour: scheduledMonitoring.startTime.hour,
      minute: scheduledMonitoring.startTime.minute
    });

    let stringArg;
    if (isScheduledForToday && !isNextWeek) {
      stringArg = { value0: startDate.format("HH:mm") };
    }
    if (isTomorrow) {
      stringArg = {
        value0: t("scheduler.nextDay", {
          value0: startDate.format("HH:mm")
        })
      };
    }
    if (!stringArg) {
      stringArg = {
        value0: `${startDate.format("HH:mm")} (${scheduler?.getClosestDay(scheduledMonitoring, true)})`
      };
    }

    return t("scheduler.toStartAt", stringArg);
  }

  const schedulerString = getCorrespondingString();

  return (
    <Flex
      bg="black30"
      p={["14px 16px", "22px 24px", "24px 24px"]}
      borderRadius={["27px", "35px", "37px"]}
      alignItems="center"
      maxWidth="60vw"
    >
      <Box
        //  width={["20px", "28px", "32px"]}
        width="clamp(2rem, 3.816vmin, 3.2rem)"
      >
        {scheduledMonitoring ? (
          <SvgContainer icon={ScheduledIcon} fill="white" />
        ) : (
          <Lottie animationName="device-icons20.json" browserProps={{ useTheme: false }} />
        )}
      </Box>
      <Subtitle2
        ml={["16px", "24px"]}
        // fontSize={["12px", "16px", "20px"]}
        fontSize="clamp(1.2rem, 2.29vmin, 2.2rem)"
        // letterSpacing={["0.4px", "0.67px", "0.8px"]}
        color="white"
      >
        {scheduler ? schedulerString : t("babyStation.monitoringStatus.waiting")}
      </Subtitle2>
    </Flex>
  );
}
